import styled from "styled-components";

const Info = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  color: ${({theme}) => theme.primaryColor};
  font-size: ${({theme}) => theme.fontMedium};
`;

export default Info;
